<script setup lang="ts">
const page = usePage().value;

const kitList = computed(() => page?.kitList ?? []);
</script>

<template>
  <section id="kitList">
    <h2>Trekking Kit List</h2>
    <!-- <h3>What to Bring on the {{ page?.parentPageTitle }}</h3> -->
    <section class="kit-wrap">
      <div v-for="(item, index) in kitList" :key="index" class="kit-item">
        <div class="kit-image">
          <NuxtPicture
            v-if="item?.kitimage"
            loading="lazy"
            :src="item?.kitimage.url"
            :width="item?.kitimage.width"
            :height="item?.kitimage.height"
            :alt="item?.kitimage.alt"
            sizes="sm:100vw md:50vw lg:600px"
          />
        </div>
        <div class="kit-meta">
          <h3>{{ item?.title }}</h3>
          <div v-html="item?.text" />
        </div>
        <AppSVGBrandGraphic />
      </div>
    </section>
  </section>
</template>
